/*
 * @Author: chj
 * @Date: 2024-10-11 10:26:58
 * @LastEditors: chj
 * @LastEditTime: 2024-10-11 10:30:27
 * @Description: 请填写简介
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import router from './modules/router'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    router,
  },
  getters
})

export default store
